export default "__VITE_ASSET__CXyHo9Hn__";